import Vue from 'vue'
import App from './App.vue'
import AppMeeting from './AppMeeting.vue'
import AppRecording from './AppRecording.vue'
import router from './router'
import meeting_router from './router/meeting.js'
import vuetify from './plugins/vuetify'
import { createPinia } from 'pinia'
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";


Vue.config.productionTip = false
Vue.use(createPinia())

//dialer app
if(document.getElementById("lead-dialer")) {
    new Vue({
        data: function () {
            return {}
        },
        router,
        vuetify,
        render: h => h(App)
    }).$mount('#lead-dialer')
}

// Sentry.init({
//     Vue,
//     dsn: "https://51bcbf0de3224e3694f1b682a5edc4d0@o4504866541010944.ingest.sentry.io/4504866542256128",
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracePropagationTargets: ["dialer-now.test", "phonelever.com", /^\//],
//       }),
//     ],
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,

//     // This sets the sample rate to be 10%. You may want this to be 100% while
//     // in development and sample at a lower rate in production
//     replaysSessionSampleRate: 1.0,
//     // If the entire session is not sampled, use the below sample rate to sample
//     // sessions when an error occurs.
//     replaysOnErrorSampleRate: 1.0,

//     integrations: [new Sentry.Replay()],
// });

//meeting app
if(document.getElementById("viphuddles-meeting")) {
    new Vue({
        data: function () {
            return {}
        },
        router: meeting_router,
        vuetify,
        render: h => h(AppMeeting)
    }).$mount('#viphuddles-meeting')
}

//recording app
if(document.getElementById("viphuddles-recording")) {
    new Vue({
        data: function () {
            return {}
        },
        router: meeting_router,
        vuetify,
        render: h => h(AppRecording)
    }).$mount('#viphuddles-recording')
}